import { USER_EMAIL, USER_ROLES } from './constants';

export const convertUserDataToTableData = ([, data]) => ({
  [`${USER_EMAIL}`]: data[USER_EMAIL],
  [`${USER_ROLES}`]: data[USER_ROLES].map((role) => role.name).join(', '),
});
